import { ticketStatusEntity, ticketPriorityEntity } from '../model/entity/enum-entities';
import { Enums } from '../helper/enums';
import { _fullName } from './technician-entity-service';
import { formatPortalDateTime } from '../helper/portal-datetime-format';
import { customStatusEntity } from '../model/entity/custom-status-entity';

export function getTicketStatusName(ticketStatusId: any) {
    if (ticketStatusId != null && ticketStatusId != 0) {
        let ticketStatus = ticketStatusEntity.query<any>().where('id', ticketStatusId).first();
        if (ticketStatus != null) {
            return ticketStatus.name;
        }
    }
    return "";
}

export function getTicketStatusEntity(ticketStatusId: any): any {
    if (ticketStatusId != null && ticketStatusId > 0) {
        if (ticketStatusId == 5) {
            return { id: 5, name: "Merged", sortOrder: 100 };
        }

        let ticketStatus = customStatusEntity.find(ticketStatusId) as any;
        if (ticketStatus != null) {
            let statusModel = {
                id: ticketStatus.ticketStatusId,
                name: ticketStatus.name,
                sortOrder: ticketStatus.sortOrder,
                statusColor: ticketStatus.color,
                percentageOfStatusIcon: ticketStatus.percentageOfStatusIcon,
                statusIcon: ticketStatus.statusIcon
            };

            return statusModel;
        }
    }
    return null;
}

export function getTicketPriorityById(ticketPriorityId: any) {

    let ticketPriority = ticketPriorityEntity.find(ticketPriorityId) as any;
    if (ticketPriority != null) {
        let priority = {
            id: ticketPriority.id,
            name: ticketPriority.name
        };
        return priority;
    }
    return null;
}

export function ticketCreatedStatus(modifiedByNameFound: any, lastModifiedByText: string, ticketStatusId: number) {
    let ticketStatus = ticketStatusEntity.query<any>().where('id', ticketStatusId).first();
    if (ticketStatus && ticketStatus.name != null) {
        let statusClass = '';
        let vowels = ['a', 'e', 'i', 'o', 'u'];
        if (ticketStatus.id == Enums.TicketStatus.New) {
            statusClass = 'error--text';
        }
        else {
            statusClass = 'warningDark--text';
        }
        if (ticketStatus.name && vowels.includes((ticketStatus.name as string).toLowerCase().charAt(0))) {
            if (modifiedByNameFound) {
                return `${lastModifiedByText} <br/>Created an <span class="${statusClass}"> ${ticketStatus.name} </span> Ticket`;
            }
            else {
                return `${lastModifiedByText} <br/>an <span class="${statusClass}"> ${ticketStatus.name} </span> Ticket was Created`;
            }
        }
        else {
            if (modifiedByNameFound) {
                return `${lastModifiedByText} <br/>Created a <span class="${statusClass}"> ${ticketStatus.name} </span> Ticket`;
            }
            else {
                return `${lastModifiedByText} <br/>a <span class="${statusClass}"> ${ticketStatus.name} </span> Ticket was Created`;
            }
        }
    }
    return `${lastModifiedByText} <br/>Created a Ticket`;
}

export function _statusChangedReason(statusChangedMessage:any) {
  
    if (statusChangedMessage && statusChangedMessage != '') {
        try {
            let object = JSON.parse(statusChangedMessage);
            if (object.reason) {
                return object.reason;
            }
        }
        catch (e) {
            return statusChangedMessage;
        }
    }
    return '';

}

export function _statusChangedInfo(statusChangedMessage:any) {
    let message: string = "";

    if (statusChangedMessage && statusChangedMessage != "") {

        try {
            let object = JSON.parse(statusChangedMessage);
            if (object.reason) {
                message = `<span class='lg--text font-weight-bold'>${object.reason}</span>`;
            }
            if (object.updatedById) {
                let technicianFullName = _fullName(object.updatedById);              
                    message += `<br/><span class='sm--text'>${technicianFullName}</span>`;              
            }
            if (object.updatedOn) {
                let customDate = formatPortalDateTime(object.updatedOn);
                message += `<br/><span class='sm--text'>${customDate}</span>`;
            }
        }
        catch (e) {
            return statusChangedMessage;
        }

    }

    return message;
}
